module.exports = __webpack_public_path__ + "img/right-registerpage@3x.4b635387.png";